import React from 'react';
import { Button } from 'is24-corecss';
import { FormattedMessage, useIntl } from 'react-intl';

import { TeamMember } from '../../../../models/TeamMember';

import styles from './styles.module.css';
import paperPlaneIcon from './paperPlane.png';
import binIcon from './bin.png';
import cancelIcon from './cancel.png';

type LifecycleProps = {
  teamMember: TeamMember;
  onClick: null | (() => void);
  command: string;
};

const LifecycleHandlerButton: (props: LifecycleProps) => JSX.Element | null = ({ teamMember, onClick, command }: LifecycleProps) => {
  const testId = `${command}-lifecycle-team-member`;
  const intl = useIntl();

  const commandButtonTranslations: Record<string, string> = {
    invite: intl.formatMessage({ id: 'teammanagement.table.lifecycle.button.invite' }),
    revokeInvitation: intl.formatMessage({ id: 'teammanagement.table.lifecycle.button.revokeInvitation' }),
    delete: intl.formatMessage({ id: 'teammanagement.table.button.delete' }),
  };

  const buttonIconMapper = () => {
    if (command === 'revokeInvitation') {
      return cancelIcon;
    } else if (command === 'invite') {
      return paperPlaneIcon;
    }
    return binIcon;
  };

  return (
    onClick && (
      <div className={styles.root}>
        <Button key={command} className={styles.actionLink} data-testid={testId} onClick={onClick}>
          <img src={buttonIconMapper()} alt='icon' className={styles.optionIcon} />
          {teamMember.status !== 'CREATED' && command == 'invite' ? (
            <FormattedMessage id='teammanagement.table.lifecycle.button.reInvite' />
          ) : (
            commandButtonTranslations[command as string]
          )}
        </Button>
      </div>
    )
  );
};
export default LifecycleHandlerButton;
